// @flow
import * as React from 'react'

import './RailSection.scss'

type Props = {
  title?: React.Node,
  synopsis?: string,
  children: React.Node,
}

export default class RailSection extends React.Component<Props> {
  render = () => {
    return (
      <div className="RailSection">
        {this.renderTitleMaybe()}
        {this.props.children}
        {this.renderSynopsisMaybe()}
      </div>
    )
  }

  renderTitleMaybe = () => {
    if (!this.props.title) return null

    return <div className="RailSection-title">{this.props.title}</div>
  }

  renderSynopsisMaybe = () => {
    if (!this.props.synopsis) return null

    return <div className="RailSection-synopsis">{this.props.synopsis}</div>
  }
}
